import { type FC } from "react";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import { TooltipWithIcon } from "@root/shared/components/TooltipWithIcon";
import * as styles from "./styles.css";

type Props = {
  text: string;
};

export const RecommendTooltip: FC<Props> = ({ text }) => (
  <TooltipWithIcon arrowPosition="leftMiddle" outerClassName={styles.tooltipOuter}>
    <div className={styles.content}>
      <MultiLineText text={text} />
    </div>
  </TooltipWithIcon>
);
